<ng-container *ngIf="fascicolo && pratica">

  <li *ngIf="isViewFascicoloView && urlPathViewFascicolo">
    <a [routerLink]="urlPathViewFascicolo"><span class="glyphicon glyphicon-eye-open"></span>Visualizza fascicolo</a>
  </li>

  <li><a href="javascript:void(0);" target="_blank"
      [routerLink]="['/scheda_analitica/fascicolo', pratica.id, pratica.tipoPratica.id, fascicolo.id]">
      <span class="glyphicon glyphicon-print"></span>Scheda analitica
    </a></li>

  <li><a href="javascript:void(0);" target="_blank"
      [routerLink]="['/scheda_sintetica/fascicolo', pratica.id, pratica.tipoPratica.id, fascicolo.id]">
      <span class="glyphicon glyphicon-print"></span>Scheda sintetica
    </a></li>

  <li *ngIf="!pratica.archiviata && pratica.tipoPratica.id !== ID_PRATICA_PARERISTICA && descrittori &&
      descrittori[keyDescrittoreCopiaFascicolo] && descrittori[keyDescrittoreCopiaFascicolo].writable &&
      !(fascicolo.stato.id === 'IN_SMISTAMENTO') && !(fascicolo.stato.id === 'IN_ASSEGNAZIONE') &&
      !(fascicolo.stato.id === 'BOZZA') && !(fascicolo.stato.id === 'IN_ASSEGNAZIONE_LEGALE') &&
      !(fascicolo.stato.id === 'DA_COMPLETARE')">
      <a href="javascript:void(0);" (click)="onClickOption('copiaFascicolo',fascicolo,pratica);"><span
        class="glyphicon glyphicon-copy"></span>Copia fascicolo</a>
  </li>
  <li *ngIf="(fascicolo.stato.id === 'IN_LAVORAZIONE')">
      <a href="javascript:void(0);" (click)="onClickOption('inviaNotifica',fascicolo,pratica);"><span
        class="glyphicon glyphicon-bell"></span>Invia Notifica di Aggiornamento</a>
  </li>

  <li *ngIf="pratica.tipoPratica.id === ID_PRATICA_PARERISTICA || !descrittori || !descrittori[keyDescrittoreCopiaFascicolo]
      || !descrittori[keyDescrittoreCopiaFascicolo].writable  || fascicolo.stato.id === 'BOZZA'
      || fascicolo.stato.id === 'IN_SMISTAMENTO' || fascicolo.stato.id === 'IN_ASSEGNAZIONE'
      || fascicolo.stato.id === 'IN_ASSEGNAZIONE_LEGALE' || fascicolo.stato.id === 'DA_COMPLETARE' "
      class="disabilitata"><span class="glyphicon glyphicon-copy"></span>Copia fascicolo
  </li>


  <!--GENERAZIONE DOCUMENTO-->
  <li
    [ngClass]="{'disabilitata' : !descrittori || !descrittori[keyDescrittoreGeneraDocumento] || !descrittori[keyDescrittoreGeneraDocumento].writable}">
    <ng-container
      *ngIf="descrittori && descrittori[keyDescrittoreGeneraDocumento] && descrittori[keyDescrittoreGeneraDocumento].writable; else generazioneDocumentodisabled">
      <a href="javascript:void(0);" style="background-color: white;border: none;"
        (click)="elemGeneraDocumento(fascicolo, pratica)"><span
          class="glyphicon glyphicon-file"></span>Genera Documento</a>
    </ng-container>
    <ng-template #generazioneDocumentodisabled>
      <span class="glyphicon glyphicon-file"></span> Genera Documento
    </ng-template>
  </li>



  <li
    *ngIf="descrittori && descrittori[keyDescrittoreDefinizione] && descrittori[keyDescrittoreDefinizione].writable && !pratica.archiviata && !fascicolo.intestazione.campi.definito && !fascicolo.intestazione.campi.riunito">
    <a href="javascript:void(0);" (click)="onClickOption('definisciFascicolo',fascicolo,pratica);">
      <span class="glyphicon glyphicon-pushpin"></span>Definisci fascicolo</a>
  </li>

  <li
    *ngIf="!descrittori || !descrittori[keyDescrittoreDefinizione] || !descrittori[keyDescrittoreDefinizione].writable || pratica.archiviata || fascicolo.intestazione.campi.definito || fascicolo.intestazione.campi.riunito"
    class="disabilitata"><span class="glyphicon glyphicon-pushpin"></span>Definisci fascicolo</li>


  <li
    *ngIf="descrittori && descrittori[keyDescrittoreRimozioneDefinizione] && descrittori[keyDescrittoreRimozioneDefinizione].writable && !pratica.archiviata && fascicolo.intestazione.campi.definito && !fascicolo.intestazione.campi.riunito">
    <a href="javascript:void(0);" (click)="onClickOption('rimuoviDefinizione',fascicolo,pratica);">
      <span class="glyphicon glyphicon-saved"></span>Rimuovi definizione</a>
  </li>

  <ng-template
    [ngIf]="!pratica.archiviata && !fascicolo.intestazione.campi.definito && !fascicolo.intestazione.campi.riunito && categoriaFascicolo != 'STRAGIUDIZIALE' && categoriaFascicolo != 'CONSULENZA'">

    <li
      *ngIf="descrittori && descrittori[keyDescrittoreRiunisciGiudizi] && descrittori[keyDescrittoreRiunisciGiudizi].writable">
      <a href="javascript:void(0);" (click)="onClickOption('riunisciGiudizi',fascicolo,pratica);">
        <span class="glyphicon glyphicon-resize-small"></span>Riunisci giudizi</a>
    </li>

    <li
      *ngIf="!descrittori || !descrittori[keyDescrittoreRiunisciGiudizi] || !descrittori[keyDescrittoreRiunisciGiudizi].writable"
      class="disabilitata"><span class="glyphicon glyphicon-resize-small"></span>Riunisci giudizi</li>
  </ng-template>

  <ng-template [ngIf]="!pratica.archiviata && pratica.riunita">

    <li
      *ngIf="descrittori && descrittori[keyDescrittoreRimozioneRiunione] && descrittori[keyDescrittoreRimozioneRiunione].writable">
      <a href="javascript:void(0);" (click)="onClickOption('rimuoviRiunioneGiudizio',fascicolo,pratica);">
        <span class="glyphicon glyphicon-resize-full"></span>Rimuovi riunione giudizio</a>
    </li>
    <li
      *ngIf="!descrittori || !descrittori[keyDescrittoreRimozioneRiunione] || !descrittori[keyDescrittoreRimozioneRiunione].writable"
      class="disabilitata"><span class="glyphicon glyphicon-resize-full"></span>Rimuovi riunione giudizio</li>
  </ng-template>

  <li
    *ngIf="isPctDepositoEnabled()">
    <a href="javascript:void(0);" (click)="onClickOption('depositoPCT',fascicolo,pratica);">
      <span class="glyphicon glyphicon-list-alt"></span>Deposito processo telematico</a>
  </li>

  <li
    *ngIf="isPctConsultazioneEnabled()">
    <a href="javascript:void(0);" (click)="onClickOption('consultazionePCT',fascicolo,pratica);">
      <span class="glyphicon glyphicon-import"></span>Consultazione processo telematico</a>
  </li>

  <li *ngIf="descrittoriSezione && descrittoriSezione['SezioneDocumentazioneAllegata'] && descrittoriSezione['SezioneDocumentazioneAllegata'].writable">
    <a href="javascript:void(0);" (click)="onClickOption('metadatiConservazione',fascicolo,pratica);">
      <span class="	glyphicon glyphicon-th-large"></span>Aggiorna metadati conservazione
    </a>
  </li>

  <li *ngIf="!descrittoriSezione || !descrittoriSezione['SezioneDocumentazioneAllegata'] || !descrittoriSezione['SezioneDocumentazioneAllegata'].writable || !descrittoriSezione['SezioneDocumentazioneAllegata'].readable" class="disabilitata">
    <span class="	glyphicon glyphicon-th-large"></span>Aggiorna metadati conservazione
  </li>

  <li
    *ngIf="descrittori && descrittori[keyDescrittoreCancellazione] && descrittori[keyDescrittoreCancellazione].writable && !pratica.archiviata && !fascicolo.intestazione.campi.definito && !fascicolo.intestazione.campi.riunito && !fascicolo.intestazione.campi.capofila">
    <a href="javascript:void(0);" (click)="onClickOption('eliminaFascicolo',fascicolo,pratica);">
      <span class="glyphicon glyphicon-trash"></span>Elimina fascicolo</a>
  </li>

  <li
    *ngIf="!descrittori || !descrittori[keyDescrittoreCancellazione] || !descrittori[keyDescrittoreCancellazione].writable || pratica.archiviata || fascicolo.intestazione.campi.definito || fascicolo.intestazione.campi.riunito || fascicolo.intestazione.campi.capofila"
    class="disabilitata"><span class="glyphicon glyphicon-trash"></span>Elimina fascicolo
  </li>

  <li>
    <a href="javascript:void(0);" (click)="onClickOption('gestioneMetadatiFascicolo',fascicolo,pratica);" style="white-space: nowrap;">
      <span class="gestione-metadati-icon"></span>Gestione Metadati</a>
  </li>
</ng-container>
<!--<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Seleziona Template</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div>
          <label for="Template">Template</label>
          <div class="wdk-select-wrapper">
            <select id="Template" name="Template" [(ngModel)]="idTemplate">
              <option [ngValue]="item.idTemplate" *ngFor="let item of templateAssociati">{{item.nome}}</option>
            </select>
          </div>
        </div>
      </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" (click)="salvaAssociazione()">Salva</button>
        </div>
      </div>
    </div>
  </div>-->
